import { useContext } from "react";
import { useSelector } from "react-redux";
import { ZoneCreationError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ZoneCreationError;
  createZone(request: Boundaries["createZone"]["request"]): void;
}

function useZoneCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isZoneCreationRequestPending),
    isRequestSuccess: useSelector(selector.isZoneCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isZoneCreationRequestFailure),
    error: useSelector(selector.getZoneCreationError),
    createZone: core.createZone,
  };
}

export { useZoneCreation };
